import TakeAwayApp from "./TakeAwayApp.vue";
import router from "./router";
import { EAT_UP_PAGES } from "@/types";
import createEatUp from "@/app";

createEatUp(TakeAwayApp, router, EAT_UP_PAGES.TAKE_AWAY_ON_SITE);
